var { getItem } = require('@managers/localStorageManager.jsx');

const DEFAULT_SEARCH_TYPE = 'FREE_SEARCH';
const SEARCH_BY_FIELD_TYPE = 'SEARCH_BY_FIELD_TYPE';

// Authentication reducers
var authenticationDataDefaults = {
  tokens: {
    id_token: getItem('ID_TOKEN', ''),
    access_token: getItem('ACCESS_TOKEN', ''),
    refresh_token: getItem('REFRESH_TOKEN', ''),
  },
  user_details: JSON.parse(getItem('USER_DETAILS', '{}')),
  user_data: {},
  user_notifications: {},
  user_notifications_flow: {
    state: '',
    user_notifications_error: '',
  },
  notifications_feed: {
    items: [],
    newestSeenDate: 0,
    oldestLoadedDate: 0,
    lastSyncAt: 0,
    loadingInitial: false,
    loadingSync: false,
    error: '',
    hydrated: false,
  },
  remote_configuration: {},
  user_discharge_tests: {},
  register_flow: {
    registered_user_name: '',
    during_register: false,
    register_status: '',
    register_fail_error: '',
    confirm_status: '',
    confirm_fail_error: '',
  },
  during_login: false,
  during_refresh_token: false,
  refresh_token_fail_error: '',
  login_fail_error: '',
  during_logout: false,
  forgot_password_flow: {
    phase: 'forgot',
    state: '',
    forgot_password_error: '',
  },
  set_user_attributes_flow: {
    state: '',
    set_user_attributes_error: '',
  },
  manual_login: false,
};

var authenticationReducer = (state = authenticationDataDefaults, action) => {
  switch (action.type) {
    case 'LOGIN_INIT':
      return {
        ...state,
        during_login: true,
      };
      break;
    case 'AUTHENTICATION_SUCCESS':
      return {
        ...state,
        tokens: {
          id_token: action.tokens.id_token,
          access_token: action.tokens.access_token,
          refresh_token: action.tokens.refresh_token,
        },
        login_fail_error: '',
        during_login: false,
      };
      break;
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        tokens: {
          id_token: action.tokens.id_token,
          access_token: action.tokens.access_token,
          refresh_token: action.tokens.refresh_token,
        },
        user_details: action.user_details,
        login_fail_error: '',
        during_login: false,
      };
      break;
    case 'SET_USER_DETAILS':
      return {
        ...state,
        user_details: action.user_details,
      };
      break;
    case 'LOGIN_FAIL':
      return {
        ...state,
        login_fail_error: action.login_fail_error,
        during_login: false,
      };
      break;
    case 'REFRESH_TOKEN_INIT':
      return {
        ...state,
        during_refresh_token: true,
      };
      break;
    case 'REFRESH_TOKEN_SUCCESS':
      return {
        ...state,
        tokens: {
          id_token: action.tokens.id_token,
          access_token: action.tokens.access_token,
          refresh_token: action.tokens.refresh_token,
        },
        refresh_token_fail_error: '',
        during_refresh_token: false,
      };
      break;
    case 'REFRESH_TOKEN_FAIL':
      // Don't clear tokens here — a refresh failure can be transient
      // (network error, timeout) and the token may still be valid.
      // The interceptor explicitly calls clearLocalStorage + logout_success
      // only when the server confirms the token is dead (4xx).
      return {
        ...state,
        refresh_token_fail_error: action.refresh_token_fail_error,
        during_refresh_token: false,
      };
      break;
    case 'REGISTER_INIT':
      return {
        ...state,
        register_flow: {
          ...state.register_flow,
          during_register: true,
          register_status: 'init',
        },
      };
      break;
    case 'REGISTER_SUCCESS':
      return {
        ...state,
        register_flow: {
          ...state.register_flow,
          register_fail_error: '',
          during_register: false,
          register_status: 'success',
          registered_user_name: action.registered_user_name,
        },
      };
      break;
    case 'REGISTER_USER_EXIST':
      return {
        ...state,
        register_flow: {
          ...state.register_flow,
          register_fail_error: '',
          during_register: false,
          register_status: 'existing_user',
          registered_user_name: action.registered_user_name,
        },
      };
      break;
    case 'REGISTER_FAIL':
      return {
        ...state,
        register_flow: {
          ...state,
          register_fail_error: action.register_fail_error,
          during_register: false,
          register_status: 'fail',
          registered_user_name: '',
        },
      };
      break;
    case 'CONFIRM_INIT':
      return {
        ...state,
        register_flow: {
          ...state,
          confirm_status: 'init',
        },
      };
      break;
    case 'CONFIRM_SUCCESS':
      return {
        ...state,
        register_flow: {
          ...state,
          confirm_fail_error: '',
          confirm_status: 'success',
        },
      };
      break;
    case 'CONFIRM_FAIL':
      return {
        ...state,
        register_flow: {
          ...state,
          confirm_fail_error: action.confirm_fail_error,
          confirm_status: 'fail',
        },
      };
      break;
    case 'FORGOT_PASSWORD_INIT':
      return {
        ...state,
        forgot_password_flow: {
          phase: 'forgot',
          state: 'forgot_init',
          forgot_password_error: '',
        },
      };
      break;
    case 'FORGOT_PASSWORD_CONFIRM_INIT':
      return {
        ...state,
        forgot_password_flow: {
          phase: 'confirm',
          state: 'confirm_init',
          forgot_password_error: '',
        },
      };
      break;
    case 'FORGOT_PASSWORD_CONFIRMATION_SENT':
      return {
        ...state,
        forgot_password_flow: {
          phase: 'confirm',
          state: 'confirmation_sent',
          forgot_password_error: '',
        },
      };
      break;
    case 'FORGOT_PASSWORD_SUCCESS':
      return {
        ...state,
        forgot_password_flow: {
          phase: 'confirm',
          state: 'success',
          forgot_password_error: '',
        },
      };
      break;
    case 'FORGOT_PASSWORD_FAIL':
      return {
        ...state,
        forgot_password_flow: {
          phase: 'forgot',
          state: 'fail',
          forgot_password_error: action.forgot_password_error,
        },
      };
      break;
    case 'FORGOT_PASSWORD_CONFIRM_FAIL':
      return {
        ...state,
        forgot_password_flow: {
          phase: 'confirm',
          state: 'fail',
          forgot_password_error: action.forgot_password_error,
        },
      };
      break;
    case 'CLEAR_FORGOT_PASSWORD_ACTIONS':
      return {
        ...state,
        forgot_password_flow: {
          phase: 'forgot',
          state: '',
          forgot_password_error: '',
        },
      };
      break;

    case 'LOGOUT_INIT':
      return {
        ...state,
        during_logout: true,
      };
      break;
    case 'LOGOUT_SUCCESS':
      return {
        ...state,
        tokens: { id_token: '', access_token: '', refresh_token: '' },
        user_details: {},
        during_logout: false,
        notifications_feed: {
          items: [],
          newestSeenDate: 0,
          oldestLoadedDate: 0,
          lastSyncAt: 0,
          loadingInitial: false,
          loadingSync: false,
          error: '',
          hydrated: false,
        },
      };
      break;
    case 'GET_USER_DATA_SUCCESS':
      return {
        ...state,
        user_data: action.userData,
        set_user_attributes_flow: {
          state: 'success',
          set_user_attributes_error: '',
        },
      };
      break;

    case 'SET_USER_ATTRIBUTES_INIT':
      return {
        ...state,
        set_user_attributes_flow: {
          state: 'init',
          set_user_attributes_error: '',
        },
      };
      break;
    case 'SET_USER_ATTRIBUTES_SUCCESS':
      return {
        ...state,
        user_details: action.user_details,
        set_user_attributes_flow: {
          state: 'success',
          set_user_attributes_error: '',
        },
      };
      break;
    case 'GET_USER_NOTIFICATIONS_SUCCESS':
      return {
        ...state,
        user_notifications: action.user_notifications,
        user_notifications_flow: {
          state: 'success',
          user_notifications_error: '',
        },
      };
      break;
    case 'HYDRATE_NOTIFICATIONS_FEED':
      return {
        ...state,
        notifications_feed: {
          ...state.notifications_feed,
          ...action.feed,
          hydrated: true,
        },
      };
      break;
    case 'SET_NOTIFICATIONS_FEED':
      return {
        ...state,
        notifications_feed: {
          ...state.notifications_feed,
          ...action.feed,
          error: '',
        },
      };
      break;
    case 'SET_NOTIFICATIONS_FEED_LOADING':
      var loadingKey =
        action.loadingType === 'initial' ? 'loadingInitial' : 'loadingSync';
      return {
        ...state,
        notifications_feed: {
          ...state.notifications_feed,
          [loadingKey]: action.isLoading,
        },
      };
      break;
    case 'NOTIFICATIONS_FEED_FAIL':
      return {
        ...state,
        notifications_feed: {
          ...state.notifications_feed,
          error: action.error,
        },
      };
      break;
    case 'GET_USER_NOTIFICATIONS_INIT':
      return {
        ...state,
        user_notifications_flow: {
          state: 'init',
          user_notifications_error: '',
        },
      };
      break;
    case 'GET_USER_NOTIFICATIONS_FAIL':
      return {
        ...state,
        user_notifications_flow: {
          state: 'fail',
          user_notifications_error: action.get_user_notifications_error,
        },
      };
      break;
    case 'SET_USER_ATTRIBUTES_FAIL':
      return {
        ...state,
        set_user_attributes_flow: {
          state: 'fail',
          set_user_attributes_error: action.set_user_attributes_error,
        },
      };
      break;
    case 'MANUAL_LOGIN':
      return {
        ...state,
        manual_login: action.manual_login,
      };
      break;
    case 'HIDDEN_ITEM_HAS_PREVIEWED':
      return {
        ...state,
        has_previewed: action.has_previewed,
      };
      break;
    case 'SET_DISCHARGE_TEST':
      return {
        ...state,
        user_discharge_tests: {
          ...state.user_discharge_tests,
          [action.field_id]: action.discharge_test,
        },
      };
      break;
    default:
      return state;
  }
};

// Distribution actions
var soil_data = {
  soil_data: null,
  soil_data_actions: {
    type: '',
    status: '',
    error: '',
  },
};

var soildDataReducer = (state = soil_data, action) => {
  switch (action.type) {
    case 'GET_SOIL_DATA_INIT':
      return {
        ...state,
        soil_data_actions: {
          type: action.type,
          status: 'init',
          error: '',
        },
      };
      break;
    case 'GET_SOIL_DATA_SUCCESS':
      return {
        ...state,
        soil_data: action.soil_data,
        soil_data_actions: {
          type: action.type,
          status: 'success',
          error: '',
        },
      };
      break;
    case 'GET_SOIL_DATA_FAIL':
      return {
        ...state,
        soil_data_actions: {
          type: action.type,
          status: 'fail',
          error: action.error_message,
        },
      };
      break;
    case 'CLEAR_SOIL_DATA_ACTIONS':
      return {
        ...state,
        soil_data_actions: {
          type: '',
          status: '',
          error: '',
        },
      };
      break;
    default:
      return state;
  }
};

// Crop Data Actions
var crop_data = {
  crop_data: null,
  crop_data_actions: {
    type: '',
    status: '',
    error: '',
  },
};

var cropdDataReducer = (state = crop_data, action) => {
  switch (action.type) {
    case 'GET_CROP_DATA_INIT':
      return {
        ...state,
        crop_data_actions: {
          type: action.type,
          status: 'init',
          error: '',
        },
      };
      break;
    case 'GET_CROP_DATA_SUCCESS':
      return {
        ...state,
        crop_data: action.crop_data,
        crop_data_actions: {
          type: action.type,
          status: 'success',
          error: '',
        },
      };
      break;
    case 'GET_CROP_DATA_FAIL':
      return {
        ...state,
        crop_data_actions: {
          type: action.type,
          status: 'fail',
          error: action.error_message,
        },
      };
      break;
    case 'CLEAR_CROP_DATA_ACTIONS':
      return {
        ...state,
        crop_data_actions: {
          type: '',
          status: '',
          error: '',
        },
      };
      break;
    default:
      return state;
  }
};

var configuration_data = {
  configuration_data: null,
  configuration_data_actions: {
    type: '',
    status: '',
    error: '',
  },
};

var configurationDataReducer = (state = configuration_data, action) => {
  switch (action.type) {
    case 'GET_REMOTE_CONFIGURATION_INIT':
      return {
        ...state,
        configuration_data: action.data,
        configuration_data_actions: {
          type: action.type,
          status: 'init',
          error: '',
        },
      };
      break;
    default:
      return state;
  }
};
var fertilizer_data = {
  fertilizer_data: null,
  fertilizer_data_actions: {
    type: '',
    status: '',
    error: '',
  },
};

var fertilizerDataReducer = (state = fertilizer_data, action) => {
  switch (action.type) {
    case 'GET_FERTILIZER_DATA_INIT':
      return {
        ...state,
        fertilizer_data_actions: {
          type: action.type,
          status: 'init',
          error: '',
        },
      };
      break;
    case 'GET_FERTILIZER_DATA_SUCCESS':
      return {
        ...state,
        fertilizer_data: action.fertilizer_data,
        fertilizer_data_actions: {
          type: action.type,
          status: 'success',
          error: '',
        },
      };
      break;
    case 'GET_FERTILIZER_DATA_FAIL':
      return {
        ...state,
        fertilizer_data_actions: {
          type: action.type,
          status: 'fail',
          error: action.error_message,
        },
      };
      break;
    case 'CLEAR_FERTILIZER_DATA_ACTIONS':
      return {
        ...state,
        fertilizer_data_actions: {
          type: '',
          status: '',
          error: '',
        },
      };
      break;
    default:
      return state;
  }
};

var farming_type_data = {
  farming_type_data: null,
  farming_type_data_actions: {
    type: '',
    status: '',
    error: '',
  },
};

var farmingTypeDataReducer = (state = farming_type_data, action) => {
  switch (action.type) {
    case 'GET_FARMING_TYPE_DATA_INIT':
      return {
        ...state,
        farming_type_data_actions: {
          type: action.type,
          status: 'init',
          error: '',
        },
      };
      break;
    case 'GET_FARMING_TYPE_DATA_SUCCESS':
      return {
        ...state,
        farming_type_data: action.farming_type_data,
        farming_type_data_actions: {
          type: action.type,
          status: 'success',
          error: '',
        },
      };
      break;
    case 'GET_FARMING_TYPE_DATA_FAIL':
      return {
        ...state,
        farming_type_data_actions: {
          type: action.type,
          status: 'fail',
          error: action.error_message,
        },
      };
      break;
    case 'CLEAR_FARMING_TYPE_DATA_ACTIONS':
      return {
        ...state,
        farming_type_data_actions: {
          type: '',
          status: '',
          error: '',
        },
      };
      break;
    default:
      return state;
  }
};

// Distribution actions
var distribution_data = {
  distributions: null,
  selected_entities: {
    distribution: null,
    farming_unit: null,
    field: null,
    sensors: null,
  },
  transmitter_coordinates: null,
  field_state: 'active',
  distribution_actions: {
    type: '',
    status: '',
    error: '',
  },
  farming_unit_actions: {
    type: '',
    status: '',
    error: '',
  },
  field_actions: {
    type: '',
    status: '',
    error: '',
  },
  farming_unit_load_history: {
    status: '',
    farming_unit_ids: [],
  },
  farming_unit_recommendations: {
    status: '',
    recommendations: [],
  },
  field_load_history: {
    status: '',
    field_ids: [],
  },
  all_distribution_load_status: {
    status: '',
  },
  pending_push_selection: null,
};

var distributionsReducer = (state = distribution_data, action) => {
  switch (action.type) {
    case 'SET_SELECTED_ENTITIES':
      return {
        ...state,
        selected_entities: {
          distribution: action.selected_distribution,
          farming_unit: action.selected_farming_unit,
          field: action.selected_field,
          sensors: action.selected_sensors,
        },
      };
      break;

    case 'SET_PENDING_PUSH_SELECTION':
      return {
        ...state,
        pending_push_selection: action.pending_push_selection,
      };
      break;

    case 'CLEAR_PENDING_PUSH_SELECTION':
      return {
        ...state,
        pending_push_selection: null,
      };
      break;

    case 'SET_FIELD_STATE':
      return {
        ...state,
        field_state: action.field_state,
      };

      break;
    case 'SET_TRANSMITTER_COORDINATES':
      return {
        ...state,
        transmitter_coordinates: action.transmitter_coordinates,
      };

      break;
    case 'SET_SELECTED_FARMING_UNIT':
      return {
        ...state,
        selected_entities: {
          farming_unit: action.selected_farming_unit,
        },
      };
      break;
    case 'SET_SELECTED_DISTRIBUTION':
      return {
        ...state,
        selected_entities: {
          distribution: action.selected_distribution,
        },
      };
      break;
    case 'LOAD_FARMING_UNIT_HISTORY_ACTION_INIT':
      return {
        ...state,
        farming_unit_load_history: {
          status: 'init',
          farming_unit_ids:
            state.farming_unit_load_history.farming_unit_ids.includes(
              action.farming_unit_id
            )
              ? state.farming_unit_load_history.farming_unit_ids
              : [
                  ...state.farming_unit_load_history.farming_unit_ids,
                  action.farming_unit_id,
                ],
        },
      };
      break;
    case 'LOAD_FARMING_UNIT_HISTORY_ACTION_CLEAR':
      return {
        ...state,
        farming_unit_load_history: {
          status: '',
          farming_unit_ids: [],
        },
      };
      break;
    case 'LOAD_FARMING_UNIT_HISTORY_ACTION_CLEAR_STATUS':
      return {
        ...state,
        farming_unit_load_history: {
          ...state.farming_unit_load_history,
          status: '',
        },
      };
      break;
    case 'LOAD_FARMING_UNIT_HISTORY_ACTION_SUCCESS':
      return {
        ...state,
        farming_unit_load_history: {
          ...state.farming_unit_load_history,
          status: 'success',
        },
      };
      break;

    case 'LOAD_FIELD_HISTORY_ACTION_INIT':
      return {
        ...state,
        field_load_history: {
          status: 'init',
          field_ids: state.field_load_history.field_ids.includes(
            action.field_id
          )
            ? state.field_load_history.field_ids
            : [...state.field_load_history.field_ids, action.field_id],
        },
      };
    case 'LOAD_FIELD_HISTORY_ACTION_CLEAR_STATUS':
      return {
        ...state,
        field_load_history: {
          ...state.field_load_history,
          status: '',
        },
      };
      break;
    case 'LOAD_FIELD_HISTORY_ACTION_SUCCESS':
      return {
        ...state,
        field_load_history: {
          ...state.field_load_history,
          status: 'success',
        },
      };
      break;
    case 'UPDATE_FIELD_HISTORICAL_DATA': {
      const { distributionId, farmingUnitId, fieldId, historicalData } =
        action.payload;
      const distributions = state.distributions?.distributions;
      if (
        !distributions?.[distributionId]?.farming_units?.[farmingUnitId]
          ?.fields?.[fieldId]
      ) {
        return state;
      }
      return {
        ...state,
        distributions: {
          ...state.distributions,
          distributions: {
            ...distributions,
            [distributionId]: {
              ...distributions[distributionId],
              farming_units: {
                ...distributions[distributionId].farming_units,
                [farmingUnitId]: {
                  ...distributions[distributionId].farming_units[farmingUnitId],
                  fields: {
                    ...distributions[distributionId].farming_units[
                      farmingUnitId
                    ].fields,
                    [fieldId]: {
                      ...distributions[distributionId].farming_units[
                        farmingUnitId
                      ].fields[fieldId],
                      historical_data: {
                        ...(distributions[distributionId].farming_units[
                          farmingUnitId
                        ].fields[fieldId].historical_data || {}),
                        ...historicalData,
                      },
                    },
                  },
                },
              },
            },
          },
        },
      };
    }
    case 'UPDATE_FARMING_UNIT_HISTORICAL_DATA': {
      const { distributionId, farmingUnitId, historicalData } = action.payload;
      const distributions = state.distributions?.distributions;
      if (!distributions?.[distributionId]?.farming_units?.[farmingUnitId]) {
        return state;
      }
      const farmingUnit =
        distributions[distributionId].farming_units[farmingUnitId];
      // Update all fields with their historical data
      const updatedFields = { ...farmingUnit.fields };
      for (const fieldId in updatedFields) {
        if (historicalData[fieldId]) {
          updatedFields[fieldId] = {
            ...updatedFields[fieldId],
            historical_data: {
              ...(updatedFields[fieldId].historical_data || {}),
              ...historicalData[fieldId],
            },
          };
        }
      }
      return {
        ...state,
        distributions: {
          ...state.distributions,
          distributions: {
            ...distributions,
            [distributionId]: {
              ...distributions[distributionId],
              farming_units: {
                ...distributions[distributionId].farming_units,
                [farmingUnitId]: {
                  ...farmingUnit,
                  fields: updatedFields,
                  historical_data: {
                    ...(farmingUnit.historical_data || {}),
                    ...historicalData[farmingUnitId],
                  },
                },
              },
            },
          },
        },
      };
    }
    case 'UPDATE_FIELD_OPTIMISTIC': {
      // Optimistically update field data in Redux state immediately after API success,
      // before load_distributions completes (which can take ~10 seconds).
      // Note: This is safe because the API already succeeded, so load_distributions
      // will fetch the same updated data from the server when it completes.
      const { distributionId, farmingUnitId, fieldObject } = action.payload;
      const distributions = state.distributions?.distributions;
      const selectedFarmingUnit = state.selected_entities?.farming_unit;
      const selectedField = state.selected_entities?.field;

      // Validate fieldObject has an id
      if (!fieldObject?.id) {
        console.warn(
          '[UPDATE_FIELD_OPTIMISTIC] fieldObject.id is missing, skipping optimistic update'
        );
        return state;
      }

      // Check if the field exists in the distributions state
      if (
        !distributions?.[distributionId]?.farming_units?.[farmingUnitId]
          ?.fields?.[fieldObject.id]
      ) {
        console.warn('[UPDATE_FIELD_OPTIMISTIC] Field not found in state:', {
          distributionId,
          farmingUnitId,
          fieldId: fieldObject.id,
        });
        return state;
      }

      // Update both: distributions structure AND selected_entities.farming_unit.fields
      return {
        ...state,
        distributions: {
          ...state.distributions,
          distributions: {
            ...distributions,
            [distributionId]: {
              ...distributions[distributionId],
              farming_units: {
                ...distributions[distributionId].farming_units,
                [farmingUnitId]: {
                  ...distributions[distributionId].farming_units[farmingUnitId],
                  fields: {
                    ...distributions[distributionId].farming_units[
                      farmingUnitId
                    ].fields,
                    [fieldObject.id]: {
                      ...distributions[distributionId].farming_units[
                        farmingUnitId
                      ].fields[fieldObject.id],
                      ...fieldObject,
                    },
                  },
                },
              },
            },
          },
        },
        selected_entities: {
          ...state.selected_entities,
          farming_unit:
            selectedFarmingUnit?.id === farmingUnitId &&
            selectedFarmingUnit?.fields?.[fieldObject.id]
              ? {
                  ...selectedFarmingUnit,
                  fields: {
                    ...selectedFarmingUnit.fields,
                    [fieldObject.id]: {
                      ...selectedFarmingUnit.fields[fieldObject.id],
                      ...fieldObject,
                    },
                  },
                }
              : selectedFarmingUnit,
          field:
            selectedField?.id === fieldObject.id
              ? {
                  ...selectedField,
                  ...fieldObject,
                }
              : selectedField,
        },
      };
    }
    case 'UPDATE_FARMING_UNIT_OPTIMISTIC': {
      // Optimistically merge a just-saved farming unit (including its sensors)
      // into Redux state immediately after the API succeeds, before
      // load_distributions completes. Needed because farming-unit sensors are
      // read via an eventually-consistent GSI (entity-index) — the immediate
      // re-pull can race GSI propagation and miss the new sensor, so it would
      // otherwise only appear after a manual refresh.
      const { distributionId, farmingUnit } = action.payload;
      const distributions = state.distributions?.distributions;
      const selectedFarmingUnit = state.selected_entities?.farming_unit;
      const selectedDistribution = state.selected_entities?.distribution;

      if (!farmingUnit?.id) {
        console.warn(
          '[UPDATE_FARMING_UNIT_OPTIMISTIC] farmingUnit.id is missing, skipping optimistic update'
        );
        return state;
      }

      const farmingUnitId = farmingUnit.id;

      if (!distributions?.[distributionId]?.farming_units?.[farmingUnitId]) {
        console.warn(
          '[UPDATE_FARMING_UNIT_OPTIMISTIC] Farming unit not found in state:',
          { distributionId, farmingUnitId }
        );
        return state;
      }

      // Merge the saved scalar props + sensors onto whichever copy of the
      // farming unit we're patching, preserving the heavy nested structures
      // (fields, historical_data) the save payload intentionally excludes.
      // selected_entities.distribution is a separate snapshot from the
      // distributions map, so all copies must be patched to update instantly.
      const mergeFarmingUnit = existing => ({
        ...existing,
        ...farmingUnit,
        fields: existing.fields,
        historical_data: existing.historical_data,
      });

      const patchDistributionFarmingUnit = distribution =>
        distribution?.farming_units?.[farmingUnitId]
          ? {
              ...distribution,
              farming_units: {
                ...distribution.farming_units,
                [farmingUnitId]: mergeFarmingUnit(
                  distribution.farming_units[farmingUnitId]
                ),
              },
            }
          : distribution;

      return {
        ...state,
        distributions: {
          ...state.distributions,
          distributions: {
            ...distributions,
            [distributionId]: patchDistributionFarmingUnit(
              distributions[distributionId]
            ),
          },
        },
        selected_entities: {
          ...state.selected_entities,
          distribution:
            selectedDistribution?.id === distributionId
              ? patchDistributionFarmingUnit(selectedDistribution)
              : selectedDistribution,
          farming_unit:
            selectedFarmingUnit?.id === farmingUnitId
              ? mergeFarmingUnit(selectedFarmingUnit)
              : selectedFarmingUnit,
        },
      };
    }
    case 'SET_ALL_DISTRIBUTIONS':
      return {
        ...state,
        distributions: action.distributions,
      };
      break;
    case 'SET_FIRST_ALL_DISTRIBUTIONS_LOAD_STATUS':
      return {
        ...state,
        all_distribution_load_status: { status: action.status },
      };
      break;
    case 'SET_SELECTED_DISTRIBUTION_NETWORK_REFRESH_STATUS':
      return {
        ...state,
        selected_distribution_network_refresh_status: action.status,
      };
      break;
    case 'DISTRIBUTION_ACTION_INIT':
      return {
        ...state,
        distribution_actions: {
          type: action.distribution_action_type,
          status: 'init',
          error: '',
        },
      };
      break;
    case 'DISTRIBUTION_ACTION_SUCCESS':
      return {
        ...state,
        distribution_actions: {
          type: action.distribution_action_type,
          status: 'success',
          error: '',
        },
      };
      break;
    case 'DISTRIBUTION_ACTION_FAIL':
      return {
        ...state,
        distribution_actions: {
          type: action.distribution_action_type,
          status: 'fail',
          error: action.error_message,
        },
      };
      break;
    case 'CLEAR_DISTRIBUTION_ACTION':
      return {
        ...state,
        distribution_actions: {
          type: '',
          status: '',
          error: '',
        },
      };
      break;
    case 'FARMING_UNIT_ACTION_INIT':
      return {
        ...state,
        farming_unit_actions: {
          type: action.farming_unit_action_type,
          status: 'init',
          error: '',
        },
      };
      break;
    case 'FARMING_UNIT_ACTION_SUCCESS':
      return {
        ...state,
        farming_unit_actions: {
          type: action.farming_unit_action_type,
          status: 'success',
          error: '',
        },
      };
      break;
    case 'FARMING_UNIT_ACTION_FAIL':
      return {
        ...state,
        farming_unit_actions: {
          type: action.farming_unit_action_type,
          status: 'fail',
          error: action.error_message,
        },
      };
      break;
    case 'CLEAR_FARMING_UNIT_ACTION':
      return {
        ...state,
        farming_unit_actions: {
          type: '',
          status: '',
          error: '',
        },
      };
      break;

    case 'FIELD_ACTION_INIT':
      return {
        ...state,
        field_actions: {
          type: action.field_action_type,
          status: 'init',
          error: '',
        },
      };
      break;
    case 'FIELD_ACTION_SUCCESS':
      return {
        ...state,
        field_actions: {
          type: action.field_action_type,
          status: 'success',
          error: '',
        },
      };
      break;
    case 'FIELD_ACTION_FAIL':
      return {
        ...state,
        field_actions: {
          type: action.field_action_type,
          status: 'fail',
          error: action.error_message,
        },
      };
      break;
    case 'CLEAR_FIELD_ACTION':
      return {
        ...state,
        field_actions: {
          type: '',
          status: '',
          error: '',
        },
      };
      break;
    case 'CLEAR_DISTRIBUTION_DATA':
      return {
        ...state,
        distributions: null,
        selected_entities: {
          distribution: null,
          farming_unit: null,
          field: null,
          sensor: null,
        },
        all_distribution_load_status: {
          status: '',
        },
        farming_unit_load_history: {
          status: '',
          farming_unit_ids: [],
        },
      };
      break;
    case 'FARMING_UNIT_RECOMMENDATIONS_LOADED':
      return {
        ...state,
        farming_unit_recommendations: {
          status: 'success',
          recommendations: action.payload.recommendations,
        },
      };
      break;
    case 'UPDATE_FIELD_RECOMMENDATION_SHOW_RATE_LINE':
      const { fieldId, showRateLine } = action.payload;
      const updatedRecommendations = {
        ...state.farming_unit_recommendations.recommendations,
        [fieldId]: {
          ...state.farming_unit_recommendations.recommendations[fieldId],
          show_rate_line: showRateLine,
        },
      };
      return {
        ...state,
        farming_unit_recommendations: {
          ...state.farming_unit_recommendations,
          recommendations: updatedRecommendations,
        },
      };
      break;
    default:
      return state;
  }
};

// roles actions
var roles_data = {
  roles: {
    selected_distribution_roles: null,
    selected_farming_unit_roles: null,
  },
  role_actions: {
    type: '',
    status: '',
    error: '',
  },
};

var rolesReducer = (state = roles_data, action) => {
  switch (action.type) {
    case 'GET_SELECTED_DISTRIBUTION_ROLES_SUCESS':
      return {
        roles: {
          ...state.roles,
          selected_distribution_roles: action.selected_distribution_roles,
        },
        role_actions: {
          type: action.type,
          status: 'success',
          error: '',
        },
      };
      break;
    case 'GET_SELECTED_FARMING_UNIT_ROLES_SUCCESS':
      return {
        roles: {
          ...state.roles,
          selected_farming_unit_roles: action.selected_farming_unit_roles,
        },
        role_actions: {
          type: action.type,
          status: 'success',
          error: '',
        },
      };
      break;
    case 'ROLES_ACTION_FAIL':
      return {
        ...state,
        role_actions: {
          type: action.type,
          status: 'fail',
          error: action.error_message,
        },
      };
      break;
    case 'ROLES_ACTION_INIT':
      return {
        ...state,
        role_actions: {
          type: action.type,
          status: 'init',
          error: '',
        },
      };
      break;
    case 'ROLE_ACTION_SUCCESS':
      return {
        ...state,
        role_actions: {
          type: action.action_type,
          status: 'success',
          error: '',
        },
      };
      break;
    case 'CLEAR_ROLES_ACTION':
      return {
        roles: {
          selected_distribution_roles: null,
          selected_farming_unit_roles: null,
        },
        role_actions: {
          type: '',
          status: '',
          error: '',
        },
      };
      break;
    default:
      return state;
  }
};

const transmitter_test_search_results_data = {
  farming_unit: null,
  field: null,
  distribution: null,
  search_type: DEFAULT_SEARCH_TYPE,
  sensor_value: '',
  transmitter_data: null,
  history_log_data: null,
};
const transmitterTestSearchResultsReducer = (
  state = transmitter_test_search_results_data,
  action
) => {
  switch (action.type) {
    case 'SET_TT_SELECTED_DISTRIBUTION':
      return {
        ...state,
        distribution: action.distribution,
      };
    case 'SET_TT_SELECTED_FARMING_UNIT':
      return {
        ...state,
        farming_unit: action.farming_unit,
      };
    case 'SET_TT_SELECTED_FIELD':
      return {
        ...state,
        field: action.field,
      };
    case 'SET_TT_SELECTED_SENSOR':
      return {
        ...state,
        sensor_value: action.sensor_value,
      };
    case 'RESET_SEARCH_RESULTS':
      return {
        farming_unit: null,
        field: null,
        distribution: null,
        search_type: DEFAULT_SEARCH_TYPE,
        sensor_value: '',
        transmitter_data: null,
      };
    case 'SET_SENSOR_VALUE':
      return {
        ...state,
        sensor_value: action.sensor_value,
      };
    case 'SET_TRANSMITTER_SEARCH_DATA':
      return {
        ...state,
        transmitter_data: action.transmitter_data,
      };
    case 'SET_SEARCH_RESULTS':
      return {
        ...state,
        distribution: action.distribution,
        farming_unit: action.farming_unit,
        field: action.field,
      };
    case 'SET_TRANSMITTER_SEARCH_TYPE':
      return {
        ...state,
        search_type: action.search_type,
      };
    case 'SET_HISTORY_LOG_DATA':
      return {
        ...state,
        history_log_data: action.history_log_data,
      };

    default:
      return state;
  }
};

const general_data = {
  sort_option: 'Alphabetical',
  current_tab: 'Overview',
  graph_type: 'wp',
};

const generalDataReducer = (state = general_data, action) => {
  switch (action.type) {
    case 'SET_SORT_OPTION':
      return { ...state, sort_option: action.sort_option };
    case 'SET_CURRENT_TAB':
      return { ...state, current_tab: action.current_tab };
    case 'SET_GRAPH_TYPE':
      return { ...state, graph_type: action.graph_type };
    default:
      return state;
  }
};

// Meteorological Stations Data
var meteorological_stations_data = {
  stations: null,
  meteorological_stations_actions: {
    type: '',
    status: '',
    error: '',
  },
};

var meteorologicalStationsReducer = (
  state = meteorological_stations_data,
  action
) => {
  switch (action.type) {
    case 'GET_METEOROLOGICAL_STATIONS_INIT':
      return {
        ...state,
        meteorological_stations_actions: {
          type: action.type,
          status: 'init',
          error: '',
        },
      };
    case 'GET_METEOROLOGICAL_STATIONS_SUCCESS':
      return {
        ...state,
        stations: action.stations,
        meteorological_stations_actions: {
          type: action.type,
          status: 'success',
          error: '',
        },
      };
    case 'GET_METEOROLOGICAL_STATIONS_FAIL':
      return {
        ...state,
        meteorological_stations_actions: {
          type: action.type,
          status: 'fail',
          error: action.error_message,
        },
      };
    default:
      return state;
  }
};

// Monday Cases Reducer
var monday_cases_data = {
  cases: [],
  technicians: [],
  countries: [],
  regions: [],
  selected_case: null,
  filter: { statuses: ['Open'], technicians: [], countries: [], regions: [] },
  mutation_queue: [],
  board_schema: {
    statuses: [],
    types: [],
    assumptions: [],
    causes: [],
    replaced_parts: [],
  },
  monday_cases_actions: { type: '', status: '', error: '' },
  done_stats: { today: 0, this_week: 0 },
};

var mondayCasesReducer = (state = monday_cases_data, action) => {
  switch (action.type) {
    case 'MONDAY_CASES_SET_CASES':
      return {
        ...state,
        cases: action.cases,
        technicians: action.technicians,
        countries: action.countries,
        regions: action.regions,
      };
    case 'MONDAY_CASES_SET_SELECTED':
      return {
        ...state,
        selected_case: action.selected_case,
      };
    case 'MONDAY_CASES_SET_FILTER':
      return {
        ...state,
        filter: { ...state.filter, ...action.filter },
      };
    case 'MONDAY_CASES_SET_BOARD_SCHEMA':
      return {
        ...state,
        board_schema: action.board_schema,
      };
    case 'MONDAY_CASES_SET_MUTATION_QUEUE':
      return {
        ...state,
        mutation_queue: action.mutation_queue,
      };
    case 'MONDAY_CASES_SET_ACTIONS':
      return {
        ...state,
        monday_cases_actions: action.monday_cases_actions,
      };
    case 'MONDAY_CASES_SET_DONE_STATS':
      return {
        ...state,
        done_stats: action.done_stats,
      };
    default:
      return state;
  }
};

// Network Error Reducer
const SET_NETWORK_ERROR = 'SET_NETWORK_ERROR';
const CLEAR_NETWORK_ERROR = 'CLEAR_NETWORK_ERROR';

const network_error_data = {
  hasError: false,
  error: null,
  timestamp: null,
};

const networkErrorReducer = (state = network_error_data, action) => {
  switch (action.type) {
    case SET_NETWORK_ERROR:
      return {
        ...state,
        hasError: true,
        error: action.payload,
        timestamp: Date.now(),
      };
    case CLEAR_NETWORK_ERROR:
      return {
        ...state,
        hasError: false,
        error: null,
        timestamp: null,
      };
    default:
      return state;
  }
};

const unitsRecalcReducer =
  require('./unitsRecalcReducer.js').unitsRecalcReducer;

module.exports = {
  DEFAULT_SEARCH_TYPE,
  SEARCH_BY_FIELD_TYPE,
  authenticationReducer,
  soildDataReducer,
  cropdDataReducer,
  configurationDataReducer,
  fertilizerDataReducer,
  farmingTypeDataReducer,
  distributionsReducer,
  rolesReducer,
  transmitterTestSearchResultsReducer,
  generalDataReducer,
  meteorologicalStationsReducer,
  networkErrorReducer,
  mondayCasesReducer,
  unitsRecalcReducer,
};
